import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, Renderer2 } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { ICRUDOptions } from '@phx-erp/shared';
import { AddressPostalLink, AddressPostalLinkSearchInput } from '../../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../../shared/components/genericBaseModelDropDown';
import { AddressPostalLinkService } from '../../../../crm/services/address-postal-link.service';

@Component({
  selector: 'app-document-deviant-invoice-receiver-dropdown',
  templateUrl: './document-deviant-invoice-receiver-dropdown.component.html',
  styleUrls: ['./document-deviant-invoice-receiver-dropdown.component.scss'],
  providers: [AddressPostalLinkService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TooltipModule,
    TranslatePipe,
  ]
})
export class DocumentDeviantInvoiceReceiverDropdownComponent extends GenericBaseModelDropDown<AddressPostalLink> {

  @Input() addressId: string;

  constructor(
    public service: AddressPostalLinkService,
    private renderer: Renderer2) {
    super(service, "AddressPostalLink");
  }

  override async executeSearch(searchInput: AddressPostalLinkSearchInput, options?: ICRUDOptions) {
    if (this.addressId) {
      searchInput.addressIdFirst = this.addressId;
      super.executeSearch(searchInput, options);
    }
    return super.executeSearch(searchInput, options);
  }

  //filter out any Items with addressId
  filterItemsByAddressId(items: AddressPostalLink[]): AddressPostalLink[] {
    let filteredItems = items?.filter(item => {
      return item.addressId != this.addressId;
    });
    return filteredItems;
  }

  sortItems(items: AddressPostalLink[]): AddressPostalLink[] {
    //sort items - show the input id first
    let sortedItems = items?.sort((a, b) => {
      if (a.addressId == this.addressId) return -1;
      if (b.addressId == this.addressId) return 1;
      return 0;
    });
    return sortedItems;
  }

  groupByFn = (item: AddressPostalLink) => {
    let debCred: string;
    if (item?.address?.debitor?.identifier && item?.address?.creditor?.identifier)
      debCred = item?.address?.debitor?.identifier + " | " + item?.address?.creditor?.identifier + " - ";
    else if (item?.address?.debitor?.identifier)
      debCred = item?.address?.debitor?.identifier + " - ";
    else if (item?.address?.creditor?.identifier)
      debCred = item?.address?.creditor?.identifier + " - ";

    return (debCred + (item?.address?.name || (item?.address?.firstName + ' ' + item?.address?.lastName)))
  }

  highlightItemCheck(item: AddressPostalLink, element: HTMLElement): boolean {
    if (item.addressId == this.addressId) {
      let highlightItem = element;
      if (highlightItem) {
        const parent = highlightItem.parentElement;
        // make the groupBy headline bolder - not possible in HTML file
        if (parent && parent.previousElementSibling && parent.previousElementSibling.classList.contains('ng-optgroup')) {
          this.renderer.setStyle(parent.previousElementSibling, 'font-weight', 'bolder');
        }
      }
      return true;
    }
    return false;
  }



}
